import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { chequeRunBreadcrumbsHistory } from './functions';

const ChequeRunBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="cheque-run-breadcrumbs"
      history={chequeRunBreadcrumbsHistory(t, location)}
    />
  );
};

export default ChequeRunBreadcrumbs;
